import { render, staticRenderFns } from "./TheDaySwiper.vue?vue&type=template&id=67123f02"
import script from "./TheDaySwiper.vue?vue&type=script&lang=js"
export * from "./TheDaySwiper.vue?vue&type=script&lang=js"
import style0 from "./TheDaySwiper.vue?vue&type=style&index=0&id=67123f02&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports